export default "__VITE_ASSET__4816TQBa__"